import { SIGN_IN } from 'actions/auth'
import { REFRESH_USER_DATA } from 'actions/users'

const setRoundups = (state, action) => action.payload.data.entities.roundups

const handlers = {
  [`${SIGN_IN}_FULFILLED`]: setRoundups,
  [`${REFRESH_USER_DATA}_FULFILLED`]: setRoundups
}

export default function roundupsReducer(state = {}, action) {
  const handler = handlers[action.type]
  return handler ? handler(state, action) : state
}
